import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SNModalService } from '@web-services/modal/snModal.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FileUploadDataProvider } from '@services/files/file-upload.data.service';
import { Subject } from 'rxjs/Subject';
import { FileUploadServiceProvider } from '@services/files/file-upload-service/file-upload.service';
import { MessageService } from '@services/helpers/message-service/message.service';
import { SNModal } from '@web-services/modal/snModal.interfaces';

@Component({
	selector: 'sn-quill-attchment-modal',
	template: require('./sn-quill-attachment.modal.html'),
	styles: [require('./sn-quill-attachment.modal.scss')]
})
export class SnQuillAttachmentModal implements OnInit, OnDestroy, SNModal {
	btnDisabled = false;
	btnLoading = false;

	files: Array<any>;
	unsubscribe: Subject<void> = new Subject<void>();
	checkedFiles: any = {};

	maxMb: number;
	maxSize: number;

	constructor(
		public activeModal: NgbActiveModal,
		private modalService: SNModalService,
		private filesDataService: FileUploadDataProvider,
		private filesService: FileUploadServiceProvider,
		private messageService: MessageService
	) {
		this.maxSize = this.filesService.maxSize;
		this.maxMb = this.filesService.maxAttachment;
	}

	addAttachment() {
		this.btnLoading = true;
		this.checkedFiles = this.files.filter(file => file.checked);

		if (this.checkedFiles && this.checkedFiles.length) {
			const size = this.filesService.getTotalSize(this.checkedFiles);

			if (size > this.maxMb) {
				this.btnLoading = false;
				this.messageService.showToaster('w_0', 'attachments');
				return;
			}
		}

		this.filesDataService.setCheckedFiles(this.checkedFiles);

		this.btnLoading = false;
		this.onDismiss();
	}

	ngOnInit() {
		this.filesDataService.filesObservable
			.takeUntil(this.unsubscribe)
			.subscribe(value => (this.files = [...value]));
	}

	ngOnDestroy() {
		this.unsubscribe.next();
	}

	onDismiss(): void {
		this.files = this.files.map(file => (file.checked = ''));
		this.modalService.setModalData(null);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/common/sn-quill-editor/modals/sn-quill-attachment-modal/sn-quill-attachment.modal.ts